define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/chart/Widget",
	"csi/html",
	"csi/locale",
	"csi/state",
	"csi/types",
	"csi/util",
	"csi/widget/FusionChartsLoader",
	"csi/xml"
], function(declare, csi, _, Widget, html, locale, state, types, util, FusionCharts, xml) {

	var BLUE_COLOR = "2d76d4";//Blue600
	var BORDER_COLOR = "C3C9D4";//Grey600
	var HEADER_COLOR = "E4E8F0";//Grey300
	var LIGHT_HEADER_COLOR = "F5F6FA";//Grey100
	var PLANNED_COLOR = "DADFE8";//Grey400
	var IN_PROCESS_COLOR = "FADEB9";//Orange100
	var SPACING = 10;

	var STATE_BORDER_COLORS = {
		Blocked: BORDER_COLOR,
		InProcess: BLUE_COLOR
	};

	var STATUS_COLORS = {
		Complete: "CAEDD4",//Green100
		CompleteLate: "CAEDD4",//Green100
		PredictedLate: "FCEBA2",//Yellow200
		Late: "F2BBB1"//Red200
	};

	var _day = (60 * 60 * 24 * 1000);

	// Boolean: enable for debug mode
	var _bDebug = false;

	function _getDataColor(wbsElement) {
		var status = xml.enumGetText(wbsElement.ScheduleStatus);
		return STATUS_COLORS[status] || IN_PROCESS_COLOR;
	}

	function _getTaskColor(wbsElement) {
		var status = xml.enumGetText(wbsElement.ScheduleStatus);
		return STATUS_COLORS[status] || "";
	}

	function _getTaskBorderColor(wbsElement) {
		var state = xml.enumGetText(wbsElement.WEState);
		return STATE_BORDER_COLORS[state] || "";
	}

	function _xmlAttr(xmlNode, attr, value) {
		if (value != null) {
			xmlNode.setAttribute(attr, value);
		}
	}

	function _xmlDataColumn(doc, datatable, id) {
		var xmlNode = xml.e(doc, "dataColumn", datatable);
		_xmlAttr(xmlNode, "headerBgColor", HEADER_COLOR);
		_xmlAttr(xmlNode, "headerText", locale.typeId("WbsElement", id));
		return xmlNode;
	}

	return declare(Widget, {
		// Number: calculated height of chart based on number of rows present
		_chartHeight: null,

		// used for hashing URLs to unique id
		_mapUrls: null,
		_nUrls: 0,
		querySize: 0,
		querySizeFixed: true,

		onData: function(/*Node[]*/nodes) {
			// summary: create flash object for chart
			var sXml = util.serializeXML(this._buildXml(nodes));
			sXml = sXml.replace(/\'/g, "&apos;");
			sXml = sXml.replace(/\"/g, "'");

			// output XML to div below chart for debugging
			if (_bDebug) {
				html.create("pre", {
					innerHTML: util.xmlToString(sXml, true)
				}, html.create("div", {
					"class": "debugView"
				}, this.domNode));
			}

			// get chart size, scaling if necessary
			var defView = this.defView;
			var chartWidth = "100%";

			var chart = null;
			if (nodes.length) {
				chart = new FusionCharts({
					type: defView.m_chartFile.toLowerCase(),
					id: csi.getUniqueId(),
					width: chartWidth,
					height: this._chartHeight,
					dataFormat: "xml",
					dataSource: sXml,
					renderAt: this.chartNode
				});
				chart.render();
			}
			return chart;
		},

		_buildView: function() {
			// summary: check to make sure latest version of node has planned start date
			this._mapUrls = this._mapUrls || {};

			if (this.cacheView.get(this.getViewURL()).PlannedStart == 0) {
				this.set("contentMessage", locale.resource("WbsGanttNoPlannedStart"));
			}
			Widget.prototype._buildView.call(this);
		},

		_buildXml: function(/*Node[]*/nodes) {
			// summary: create xml for Gantt chart
			var defView = this.defView;
			var cache = this.cacheView;
			var doc = util.newXMLDocument();
			var xmlChart = doc.createElement("chart");
			var datePattern = types.getDatePattern(true);
			var fontSize = state.get("print") ? 10 : 12;

			// FusionCharts wants "mm" for month, but normally that means minutes, so need to switch to "MM" for Dojo
			this._datePattern = datePattern.replace(/m/g, "M");

			_xmlAttr(xmlChart, "animation", "0");
			_xmlAttr(xmlChart, "baseFont", "Centric8");
			_xmlAttr(xmlChart, "captionAlignment", "center");
			_xmlAttr(xmlChart, "canvasBorderColor", BORDER_COLOR);
			_xmlAttr(xmlChart, "chartBottomMargin", "40");
			_xmlAttr(xmlChart, "dateFormat", datePattern);
			_xmlAttr(xmlChart, "decimalSeparator", types.getNumberDecimal());
			_xmlAttr(xmlChart, "flatScrollBars", "1");
			_xmlAttr(xmlChart, "ganttPaneDurationUnit", "m");
			_xmlAttr(xmlChart, "gridBorderColor", BORDER_COLOR);
			_xmlAttr(xmlChart, "showCanvasBorder", "1");
			_xmlAttr(xmlChart, "showFullDataTable", "0");
			_xmlAttr(xmlChart, "showSlackAsFill", "0");
			_xmlAttr(xmlChart, "taskBarFillMix", "light+0");
			_xmlAttr(xmlChart, "theme", "centrictheme");
			_xmlAttr(xmlChart, "thousandSeparator", types.getNumberGroup());
			_xmlAttr(xmlChart, "trendValueFontSize", fontSize);
			_xmlAttr(xmlChart, "trendValueBorderPadding", "10");
			_xmlAttr(xmlChart, "usePlotGradientColor", "0");
			_xmlAttr(xmlChart, "useVerticalScrolling", "0");

			// add hover properties when not printing
			if (state.get("print")) {
				_xmlAttr(xmlChart, "showHoverEffect", "0");
			} else {
				_xmlAttr(xmlChart, "hoverBandColor", "E6F2FC");//Blue50
				_xmlAttr(xmlChart, "hoverBandAlpha", "100");
			}

			doc.appendChild(xmlChart);

			var sPlanned = locale.resource("WbsGanttPlanned");
			var nProcesses = 0;
			var nTabs = 0;

			// determine start day - if actual startexists, then use that, otherwise use planned; if not planned, then use today
			var wbsRoot = this.getViewNode();
			var start1 = wbsRoot.PlannedStart;
			var start2 = wbsRoot.ActualStart;
			var start = ((start1 < start2) || !start2) ? start1 : start2;

			// determine end day
			var end1 = wbsRoot.PlannedEnd;
			var end2 = wbsRoot.ActualEnd;
			var end3 = wbsRoot.ExpectedEnd;
			var end = Math.max(end1, Math.max(end2, end3));

			// set chart caption
			var startChart = types.formatTime(start);
			var endChart = types.formatTime(end);

			_xmlAttr(xmlChart, "caption", locale.resource("WbsGanttCategories", [wbsRoot.$Name, startChart, endChart]));

			// set dates to first day of the start month and last day of ending month
			var dtStart = types.getTimeDate(start);
			var dtEnd = types.getTimeDate(end);

			dtStart.setDate(1);
			dtEnd.setMonth(dtEnd.getMonth() + 1);
			dtEnd.setDate(0);
			start = types.getDateTime(dtStart);
			end = types.getDateTime(dtEnd);

			// add trend line for today's date
			var dtToday = new Date();
			var today = types.getDateTime(dtToday);
			var dtTomorrow = new Date();
			dtTomorrow.setDate(dtTomorrow.getDate() + 1);
			var tomorrow = types.getDateTime(dtTomorrow);

			// for testing today-label overflow
			//var dtToday = types.getTimeDate(today);
			//dtToday.setDate(1);
			//dtToday.setHours(0, 0, 0, 0);
			//today = types.getDateTime(dtToday);

			var todayLabelLeftOverflowRisk = false;
			var todayLabelRightOverflowRisk = false;
			var todayLabelOverflowPadDays;

			if ((today >= start) && (today <= end)) {
				var l = xml.e(doc, "line", xml.e(doc, "trendlines", xmlChart));
				_xmlAttr(l, "start", this._date(today));
				_xmlAttr(l, "end", this._date(tomorrow));
				_xmlAttr(l, "displayValue", locale.resource("WbsGanttToday") + ' \n' + types.getDateInYearString(dtToday));
				_xmlAttr(l, "isTrendZone", 1);
				_xmlAttr(l, "color", BLUE_COLOR);
				_xmlAttr(l, "alpha", 9);

				var totalSeconds = end - start;
				todayLabelLeftOverflowRisk = (today - start) / totalSeconds < 0.05;
				todayLabelRightOverflowRisk = (end - tomorrow) / totalSeconds < 0.05;
				if (todayLabelLeftOverflowRisk || todayLabelRightOverflowRisk)
					todayLabelOverflowPadDays = Math.floor((totalSeconds * 0.05) / _day);
			}

			// create month categories
			//	<category start="'1/3/2008'" end="'31/3/2008'" label="'March'" />
			var categories = xml.e(doc, "categories", xmlChart);
			var nMonths = 0;

			_xmlAttr(categories, "bgColor", LIGHT_HEADER_COLOR);
			_xmlAttr(categories, "verticalPadding", "5");

			if (todayLabelLeftOverflowRisk) {
				dtStart = types.getTimeDate(start);
				dtStart.setDate(-todayLabelOverflowPadDays);
				dtEnd = types.getTimeDate(start);
				dtEnd.setDate(0);
				this.createMonth(doc, categories, dtStart, dtEnd, false);
				++nMonths;
			}

			while (start < end) {
				dtStart = types.getTimeDate(start);
				dtStart.setDate(1);
				dtEnd = types.getTimeDate(start);
				dtEnd.setMonth(dtEnd.getMonth() + 1);
				dtEnd.setDate(0);

				this.createMonth(doc, categories, dtStart, dtEnd, true);

				// add month to start
				start += 31 * _day;
				++nMonths;
			}

			if (todayLabelRightOverflowRisk) {
				dtStart = types.getTimeDate(end);
				dtStart.setDate(1);
				dtStart.setMonth(dtStart.getMonth() + 1);
				dtEnd = types.getTimeDate(end);
				dtEnd.setDate(1 + todayLabelOverflowPadDays);
				dtEnd.setMonth(dtStart.getMonth());
				this.createMonth(doc, categories, dtStart, dtEnd, false);
				++nMonths;
			}

			_xmlAttr(categories, "fontSize", fontSize);
			_xmlAttr(categories, "showHoverBand", 0);
			_xmlAttr(xmlChart, "ganttPaneDuration", Math.min(nMonths, 13));

			// processes
			var processes = xml.e(doc, "processes", xmlChart);
			_xmlAttr(processes, "align", "left");
			_xmlAttr(processes, "bgColor", LIGHT_HEADER_COLOR);
			_xmlAttr(processes, "headerBgColor", HEADER_COLOR);
			_xmlAttr(processes, "headerFontSize", fontSize);
			_xmlAttr(processes, "headerText", locale.type("WbsElement"));

			// datatable
			var datatable = xml.e(doc, "dataTable", xmlChart);
			_xmlAttr(datatable, "bgColor", LIGHT_HEADER_COLOR);
			_xmlAttr(datatable, "fontSize", fontSize);
			_xmlAttr(datatable, "headerFontSize", fontSize);
			_xmlAttr(datatable, "showProcessName", 1);

			var dataRU = _xmlDataColumn(doc, datatable, "ResponsibleUser");
			var dataFD = _xmlDataColumn(doc, datatable, "FloatDays");
			var dataST = _xmlDataColumn(doc, datatable, "WEState");
			var dataFC = _xmlDataColumn(doc, datatable, "FractionComplete");
			var dataSS = _xmlDataColumn(doc, datatable, "ScheduleStatus");

			// tasks
			var tasks = xml.e(doc, "tasks", xmlChart);

			// iterate for processes, datatable, tasks, connectors
			var onElement = function(wbsElem) {
				var state = locale.getEnumName(wbsElem.WEState);
				var user = cache.getNode(wbsElem.ResponsibleUser, true);
				var percent = Math.round(wbsElem.FractionComplete * 100);
				var scheduleStatus = locale.getEnumName(wbsElem.ScheduleStatus) || "";
				var dataColor = _getDataColor(wbsElem);
				var taskColor = _getTaskColor(wbsElem);
				var taskBorderColor = _getTaskBorderColor(wbsElem);
				var children = cache.getChildren(wbsElem, "Elements") || [];
				var fd = wbsElem.FloatDays;
				var id = this._hashUrl(wbsElem.$URL);
				var task;
				var text;

				// process
				var process = xml.e(doc, "process", processes);
				var sTabs = "";

				for (var i = 0; i < nTabs; ++i)
					sTabs += "    ";

				_xmlAttr(process, "label", sTabs + locale.getNodeName(wbsElem));
				_xmlAttr(process, "id", id);
				_xmlAttr(process, "height", "50");

				// dataColumn: ResponsibleUser
				text = xml.e(doc, "text", dataRU);
				_xmlAttr(text, "label", user ? locale.getNodeName(user) : "");

				// dataColumn: FloatDays
				text = xml.e(doc, "text", dataFD);
				_xmlAttr(text, "label", fd);

				// dataColumn: State
				text = xml.e(doc, "text", dataST);
				_xmlAttr(text, "label", state);
				if (dataColor) {
					_xmlAttr(text, "bgColor", dataColor);
				}

				// dataColumn: FractionComplete
				text = xml.e(doc, "text", dataFC);
				_xmlAttr(text, "label", percent + "%");

				// dataColumn: ScheduleStatus
				text = xml.e(doc, "text", dataSS);
				_xmlAttr(text, "label", scheduleStatus);
				if (dataColor) {
					_xmlAttr(text, "bgColor", dataColor);
				}

				// tasks
				start1 = wbsElem.ActualStart;
				end1 = wbsElem.ActualEnd;
				start2 = wbsElem.ExpectedStart;
				end2 = wbsElem.ExpectedEnd;

				// task: planned
				task = this.createTask(doc, tasks, sPlanned, id, SPACING, wbsElem.PlannedStart, wbsElem.PlannedEnd);

				_xmlAttr(task, "borderColor", PLANNED_COLOR);
				_xmlAttr(task, "color", PLANNED_COLOR);

				if (task && children.length) {
					_xmlAttr(task, "showAsGroup", 1);
				}

				// task: actual
				if (start1 || start2) {
					if (task = this.createTask(doc, tasks, state, id, 3 * SPACING, start1 || start2, end1 || end2)) {
						_xmlAttr(task, "percentComplete", percent);
						_xmlAttr(task, "borderColor", taskBorderColor || taskColor || BORDER_COLOR);
						_xmlAttr(task, "color", taskColor);
					}
				}

				// iterate over children
				++nTabs;
				_.each(children, onElement, this);
				--nTabs;

				++nProcesses;
			};

			_.each(nodes, onElement, this);

			// set width and height of chart based on number of tasks and browser width
			if (!state.get("print")) {
				defView.m_chartWidth = Math.max(html.getPageWidth() - 30, 800);
			}

			// calculate full height of chart, including 80 for header, 50 for footer, and 50 per process
			this._chartHeight = 80 + 50 + 50 * nProcesses;

			return xmlChart;
		},

		createMonth: function(doc, categories, dtStart, dtEnd, withLabel) {
			var c = xml.e(doc, "category", categories);
			_xmlAttr(c, "label", withLabel ? types.getDateMonthString(dtStart) : " ");
			_xmlAttr(c, "start", this._date(types.getDateTime(dtStart)));
			_xmlAttr(c, "end", this._date(types.getDateTime(dtEnd)));
		},

		createTask: function(doc, tasks, sLabel, id, nPadding, t1, t2) {
			// add day to end so that it spans to beginning of next day
			if (!t1 && !t2)
				return null;

			// ensure that both dates are valid
			if (!t1) t1 = t2;
			if (!t2) t2 = t1;

			var s1 = types.formatTime(t1);
			var s2 = types.formatTime(t2);
			var task = xml.e(doc, "task", tasks);

			_xmlAttr(task, "processId", id);
			_xmlAttr(task, "height", SPACING);
			_xmlAttr(task, "topPadding", nPadding);
			_xmlAttr(task, "start", this._date(t1));
			_xmlAttr(task, "end", this._date(t2 + _day));
			_xmlAttr(task, "toolText", sLabel + ", " + s1 + ((s1 == s2) ? "" : " - " + s2));

			return task;
		},

		_date: function(/*Number*/value) {
			// summary: get date string for given value - must match chart date pattern
			return types.getFormattedDateString(types.getTimeDate(value), null, this._datePattern);
		},

		_hashUrl: function(/*String*/url) {
			// summary: use generated id rather than actual URL (makes XML shorter)
			this._mapUrls[url] = this._mapUrls[url] || ++this._nUrls;
			return "uid" + this._mapUrls[url];
		}
	});
});